import React from "react";
import { useNavigate } from "react-router-dom/dist";
import { FundraiserSubsequentInfo } from "../../Interfaces/Fundraiser";

type EditDivisionProps = {
  fundraiserID: number;
};

const EditDivisionButton: React.FC<EditDivisionProps> = ({ fundraiserID }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    const fundraiserInfo: FundraiserSubsequentInfo = {
      fundraiserID: fundraiserID,
      teamAdminName: "Team Rep",
      primaryDivisionName: "Primary Division",
      secondaryDivisionName: "Secondary Division",
    };
    navigate("/create-fundraiser/division-info", { state: fundraiserInfo });
  };

  const buttonStyle: React.CSSProperties = {
    padding: "10px 20px",
    backgroundColor: "#193288",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    minHeight: "50px",
    flexGrow: 2, // Makes it expand inside a flex container
    width: "75%",
  };

  return (
    <button onClick={handleClick} style={buttonStyle}>
      Update Divisions
    </button>
  );
};

export default EditDivisionButton;
